import { apiClient } from '@/api/client';
import type { EmailPreferences } from '@/lib/types/email-preferences';

const EMAIL_PREFERENCES_PATH = '/me/email-preferences';

/** Read the signed-in member's optional-email preference. */
export async function getEmailPreferences(): Promise<EmailPreferences> {
  const res = await apiClient.get<EmailPreferences>(EMAIL_PREFERENCES_PATH);
  return res.data;
}

/**
 * Opt the signed-in member out of, or back in to, optional email.
 *
 * The body carries the flag only: the Backend keys the write on the session
 * user, and no user id is ever accepted from the client (FR-164).
 */
export async function updateEmailPreferences(optedOut: boolean): Promise<EmailPreferences> {
  const res = await apiClient.patch<EmailPreferences>(EMAIL_PREFERENCES_PATH, { optedOut });
  return res.data;
}
